import sessionReducer from "../../client/src/CoreModules/SessionManagement/reducer"
import modalReducer from "../../client/src/CoreModules/Modal/reducer"
import navbarReducer from "../../client/src/CoreModules/Navbar/reducer"

export default {
  sessionReducer,
  modalReducer,
  navbarReducer,
}
